import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarPlus,
  faQrcode,
  faHandshake,
  faFileLines,
  faClockRotateLeft,
  faChartLine,
  faMagnifyingGlass,
  faUserClock,
  faBrain,
  faGear,
} from "@fortawesome/free-solid-svg-icons";

const tabConfig = [
  {
    title: "Appointments",
    icon: faCalendarPlus,
    subTabs: [
      { label: "Create Appointment", route: "/gas-createappointment", emoji: "📝" },
      { label: "Walk-in Entry", route: "/gas-walkinentry", emoji: "🚶" },
      { label: "Missed Appointments", route: "/gas-missedappointments", emoji: "⏰" },
    ],
  },
  {
    title: "Access",
    icon: faQrcode,
    subTabs: [
      { label: "Generate Entry Pass", route: "/gas-entrypass", emoji: "🎫" },
      { label: "Scan Log", route: "/gas-log", emoji: "📜" },
    ],
  },
  {
    title: "Requests",
    icon: faHandshake,
    subTabs: [
      { label: "Appointment Requests", route: "/gas-request", emoji: "📨" },
    ],
  },
  {
    title: "Notes & MoM",
    icon: faFileLines,
    subTabs: [
      { label: "Appointment Notes", route: "/gas-notes", emoji: "🗒️" },
      { label: "Minutes of Meeting", route: "/mom", emoji: "🕒" },
    ],
  },
  {
    title: "Insights",
    icon: faChartLine,
    subTabs: [
      { label: "Analytics", route: "/gas-analytics", emoji: "📊" },
      { label: "AI Insights", route: "/gas-aiinsights", emoji: "🤖" },
    ],
  },
  {
    title: "Utilities",
    icon: faMagnifyingGlass,
    subTabs: [
      { label: "Search Appointment", route: "/gas-search", emoji: "🔍" },
      { label: "Settings", route: "/gas-settings", emoji: "⚙️" },
    ],
  },
];


const GASHome = () => {
  const [activeTab, setActiveTab] = useState(null);
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black text-cyan-400 flex flex-col">
      <div className="sticky top-0 z-50">
        <header className="bg-black border-b border-cyan-600 px-4 py-3 flex justify-between items-center">
            <div className="flex flex-col">
              <h1 className="text-lg lg:text-xl text-left font-semibold text-yellow-200">🌐📅 G.A.S</h1>
              <p className="text-xs lg:text-sm text-white">A Global Appointment System</p>
            </div>
            <select className="bg-black border border-cyan-500 text-cyan-400 rounded px-2 py-1 text-sm">
            <option>MSME Owner</option>
            <option>Corporate</option>
            <option>Individual</option>
            <option>Security</option>
            </select>
        </header>
      </div>

      <main className="flex-1 px-4 py-2">
        <div className="grid grid-cols-3 lg:grid-cols-6 gap-4 text-center place-items-center border-b border-cyan-500 py-2">
          {tabConfig.map((tab, index) => (
            <button
              key={index}
              onClick={() => setActiveTab(activeTab === index ? null : index)}
              className="border border-cyan-500 rounded-xl p-4 hover:bg-cyan-900 transition"
            >
              <FontAwesomeIcon icon={tab.icon} size="2x" />
              <p className="mt-2 text-sm">{tab.title}</p>
            </button>
          ))}
        </div>

        {activeTab !== null && (
          <div className="mt-6 grid grid-cols-3 gap-3 text-center place-items-center">
            {tabConfig[activeTab].subTabs.map((sub, i) => (
              <button
                key={i}
                onClick={() => navigate(sub.route)}
                className="border border-cyan-400 rounded-lg px-4 py-3 text-center hover:bg-cyan-800 transition flex flex-col items-center justify-center gap-1"
              >
                <span className="text-2xl">{sub.emoji}</span>
                <span className="text-sm">{sub.label}</span>
              </button>
            ))}
          </div>
        )}
      </main>
    
        <div className="sticky bottom-0 z-40">
            <footer className="bg-black border-t border-blue-400 text-white py-4">
                <div className="mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
                <div className="text-xs lg:text-sm text-yellow-200">
                    © 2025 Think5Whys Global DeepTech Solutions.
                </div>
                <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
                    <Link to="/about-us" className="text-white hover:text-blue-700">About</Link>
                    <Link to="/privacy-policy" className="text-white hover:text-blue-700">Privacy Policy</Link>
                    <Link to="/terms-of-use" className="text-white hover:text-blue-700">Terms of Use</Link>
                    <Link to="/contact-us" className="text-white hover:text-blue-700">Contact</Link>
                </div>
                </div>
            </footer>
        </div>
    </div>
  );
};

export default GASHome;
